import script from "./AboutContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutContactUs.vue?vue&type=script&setup=true&lang=js"

import "./AboutContactUs.vue?vue&type=style&index=0&id=641bd863&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641bd863"]])

export default __exports__